import I18n from 'lib/i18n/i18n';
import echarts from 'echarts';

export function getOption(props, isIphone){
    let option = {
        grid:{
            left: '1%',
            right: '0',
            bottom: '20',
            top: '25%'
        },
        dataZoom:{
            type:'inside',
            disabled: true
        },
        xAxis: [{
            type : 'category',
            data : [I18n.getString('itemPage::trends::similarValuables::yourItem'), I18n.getString('itemPage::trends::similarValuables::otherSellers', {sellerNumber: props.sellerNumber})],
            axisTick: {
                alignWithLabel: true,
                show: false  
            },
            axisLine:{
                show: false
            },
            axisLabel:{
                fontWeight: 600,
                fontSize: 14,
                padding: isIphone ? -2 : 0
            }
        }],
        yAxis: [{
            position: 'left',
            name: '$',
            type: 'value',
            nameTextStyle:{
                color: '#000000',
                fontSize: 14,
                fontWeight: 600
            },
            axisLabel: {
                show: false
            },
            axisLine:{
                lineStyle:{
                    color: '#eeeeee'
                }
            },
            axisTick:{
                show: false  
            },
            splitLine:{
                lineStyle:{
                    color: '#eeeeee'
                }
            }
        }],
        series: [{
            type: 'bar',
            barWidth: '17%',
            data: [{
                    name: props.itemValue ? Math.round(props.itemValue).toLocaleString('en') : 0,
                    value: props.itemValue,
                    itemStyle:{
                        color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                            offset: 0,
                            color: I18n.getString('itemPage::trends::similarValuables::colors::lightItem')
                        }, {
                            offset: 1,
                            color: I18n.getString('itemPage::trends::similarValuables::colors::darkItem')
                        }])
                    }
                }, 
                {
                    name: props.otherItemsValue ? Math.round(props.otherItemsValue).toLocaleString('en') : 0,
                    value: props.otherItemsValue,
                    itemStyle:{
                        color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                                    offset: 0,
                                    color: I18n.getString('itemPage::trends::similarValuables::colors::lightSimilar')
                                }, {
                                    offset: 1,
                                    color: I18n.getString('itemPage::trends::similarValuables::colors::darkSimilar')
                                }])
                    }
                }],
            label: {
                normal: {
                    formatter: '${b}',
                    show: true,
                    position: 'top',
                    fontWeight: 600,
                    fontSize: 16,
                    color: '#000000'
                }
            }
        }]
    };
    return option;
}